import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function fusionVerifyLicense(key, code, lat, lon) {
  try {
    loginfo();
    return await apiClient.post('/fusionActivateLicense', {
      licenseKey: key,
      code: code,
      lat: lat,
      lon: lon,
    });
  } catch (error) {
    console.error('fusionActivateLicense failed.', error);
  }
}

export async function fusionGetLicense(code) {
  try {
    return await apiClient.get(`/fusionFetchLicense?code=${code}`);
  } catch (error) {
    console.error('fusionFetchLicense failed.', error);
  }
}
